import { parseToHsl, hslToColorString, darken } from 'polished';

export default (hexColor: string) => {
  if (typeof hexColor === 'string') {
    const hslObj = parseToHsl(hexColor);
    return `linear-gradient(to top, ${darken(0.05, hslToColorString(hslObj))}, ${hslToColorString(hslObj)})`;
  }
  return undefined;
};
